import { createSlice } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { isDisplayFormatEnabled } from 'common/helpers/featureFlags';

export const initialState = {
  libraryItems: {},
  reportPreviewProps: {},
};

const libraryItemsSlice = createSlice({
  name: 'libraryItemsSlice/getLibraryItems',
  initialState,
  reducers: {
    updateLibraryItem: (state, action) => {
      const { libraryItems, libraryItemsSvgHtml } = state;
      const { id, item, libraryItemFormat } = action.payload;
      const updatedLibraryItems = { ...libraryItems };
      const updatedLibraryItemsSvgHtml = { ...libraryItemsSvgHtml };

      if (libraryItemFormat && isDisplayFormatEnabled) {
        updatedLibraryItemsSvgHtml[id] = Object.fromEntries(
          new Map(libraryItemFormat.map((obj) => [obj.formatType, obj])).set()
        );
      }

      if (item) {
        updatedLibraryItems[id] = String(item);
      }
      return {
        ...state,
        libraryItems: updatedLibraryItems,
        libraryItemsSvgHtml: isDisplayFormatEnabled
          ? updatedLibraryItemsSvgHtml
          : undefined,
      };
    },
    setReportPreviewProps: (state, action) => ({
      ...state,
      reportPreviewProps: {
        ...(state || {}).reportPreviewProps,
        ...cloneDeep(action.payload),
      },
    }),
  },
});

export const { updateLibraryItem, setReportPreviewProps } =
  libraryItemsSlice.actions;
export const { reducer: libraryItemsReducer } = libraryItemsSlice;

export const getLibraryItemsSelector = (state) => state.libraryItems;
export const getReportPreviewPropsSelector = (state) => {
  return (state.libraryItems || {}).reportPreviewProps;
};
export const getCachedLibraryItemsSvgHtml = (state) => {
  return (state.libraryItems || {}).libraryItemsSvgHtml;
};
